/**
 * Global SDK constants
 */

/**
 * Default tracking domain (hardcoded for production)
 */
export const DEFAULT_TRACKING_DOMAIN = "track.adscrush.com"

/**
 * Default cookie expiration in days
 */
export const DEFAULT_COOKIE_EXPIRY = 30

/**
 * Default URL parameter names for click ID, in priority order.
 * The platform redirect injects `clickid`; `tid` is kept as the legacy alias.
 */
export const DEFAULT_PARAM_NAMES: readonly string[] = ["clickid", "tid"]

/**
 * @deprecated Use {@link DEFAULT_PARAM_NAMES} — kept so existing imports keep
 * compiling. Single-parameter behavior is still available via
 * `init({ paramName: "tid" })`.
 */
export const DEFAULT_PARAM_NAME = "tid"

/**
 * Storage key for click ID
 */
export const CLICK_ID_KEY = "adscrush_tid"

/**
 * Storage key prefix for deduplication flags
 */
export const DEDUP_KEY_PREFIX = "adscrush_dedup_"
